import { __awaiter } from "tslib";
import React from 'react';
import { createContainer } from 'unstated-next';
// @ts-ignore
import ClockSkew from 'clockskew/client';
import { useLazyQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
const heartbeatQuery = gql `
  query heartbeat($key: String!) {
    heartbeat(key: $key) {
      serverTime
    }
  }
`;
const useServerSync = (key) => {
    const [skew, setSkew] = React.useState(0);
    const [fetch, { data }] = useLazyQuery(heartbeatQuery, {
        fetchPolicy: 'network-only'
    });
    React.useEffect(() => {
        if (!key) {
            return;
        }
        const serverClient = new ClockSkew({
            timeout: 10000,
            interval: 5000,
            history: 10,
            tolerance: 2,
            waitInteval: 30000,
            minSkewValues: 4,
            minRttValues: 5,
            getServerTime: (getTime, callback) => __awaiter(void 0, void 0, void 0, function* () {
                const start = getTime();
                yield fetch({ variables: { key } });
                const end = getTime();
                callback(null, [start, new Date(data === null || data === void 0 ? void 0 : data.heartbeat.serverTime).getTime(), end]);
            }),
            onSkew(skew) {
                setSkew(skew);
            }
        });
        serverClient.start();
        return () => {
            serverClient.stop();
        };
    }, [key]);
    return {
        skewMs: skew
    };
};
export const ServerSync = createContainer(useServerSync);
//# sourceMappingURL=useServerSync.js.map